/** Stable across hydration, repeated starts and clock adjustments. */
export function workoutNativeSessionId(accountId: string, workoutId: string) {
  return `workout:${encodeURIComponent(accountId)}:${encodeURIComponent(workoutId)}`;
}

// Protect in-flight callbacks from mounted logger/banner instances after finish.
const endedSessions = new Set<string>();
export function markNativeWorkoutEnded(sessionId: string) {
  endedSessions.add(sessionId);
}
export function isNativeWorkoutEnded(sessionId: string) {
  return endedSessions.has(sessionId);
}
